import {CheckCircle} from '@mui/icons-material';
import {Box, Drawer, List, ListItem, ListItemButton, Typography} from '@mui/material';
import {TableOfContentsItem} from './StudyPageTableOfContents';

export interface StudyPageTableOfContentsDrawerProps {
  open: boolean;
  onClose: () => void;
  items: TableOfContentsItem[];
  currentIndex: number;
  onItemClick: (index: number) => void;
  subjectColor: {bg: string; border: string};
}

export default function StudyPageTableOfContentsDrawer({
  open,
  onClose,
  items,
  currentIndex,
  onItemClick,
  subjectColor,
}: StudyPageTableOfContentsDrawerProps) {
  return (
    <Drawer anchor="right" open={open} onClose={onClose} data-testid="study-page-toc-drawer">
      <Box sx={{width: 280, p: {xs: 1.5, sm: 2}}}>
        <Typography variant="h6" sx={{fontWeight: 600, mb: 2}}>
          Table of Contents
        </Typography>
        <List dense>
          {items.map((item) => (
            <ListItem key={item.id} disablePadding>
              <ListItemButton
                selected={item.index === currentIndex}
                onClick={() => {
                  onItemClick(item.index);
                  onClose();
                }}
                sx={{
                  borderRadius: 1,
                  '&.Mui-selected': {
                    bgcolor: `${subjectColor.bg}`,
                    color: subjectColor.border,
                    fontWeight: 600,
                    '&:hover': {
                      bgcolor: `${subjectColor.bg}`,
                    },
                  },
                  ...(item.completed &&
                    !(item.index === currentIndex) && {
                      color: 'success.main',
                      '&:hover': {
                        bgcolor: 'success.light',
                        opacity: 0.8,
                      },
                    }),
                }}
                data-testid={`study-page-toc-item-${item.index}`}
              >
                {item.completed && <CheckCircle sx={{fontSize: '0.875rem', mr: 1}} />}
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: '0.875rem',
                    ...(item.completed && {
                      fontWeight: 500,
                    }),
                  }}
                >
                  {item.title}
                </Typography>
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
    </Drawer>
  );
}
